import { ChevronDown } from 'lucide-react'

import { Button } from '../ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import LoadingSpin from './LoadingSpin'

export interface BtnActions {
  icon?: React.ReactNode
  loading?: boolean
  title: string
  action?: (close: Function) => void
  disabled?: boolean
}

interface MultiBtn {
  btnIcon?: React.ReactNode
  btnName?: string
  items: BtnActions[]
  size?: 's' | 'm'
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export default function MultipleActBtn({
  btnIcon,
  btnName,
  items,
  size = 'm',
}: MultiBtn) {
  return (
    <div className="z-20 inline-flex flex-shrink-0 shadow-sm">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="gap-1">
            <span>{btnName ?? 'Acciones'}</span>
            <ChevronDown className="h-3.5 w-3.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {items.map((item) => (
            <DropdownMenuItem
              key={item.title}
              className="hover:cursor-pointer"
              onClick={() => {
                item.action && item.action(close)
              }}
              disabled={item.disabled}
            >
              {item?.loading ? (
                <LoadingSpin color="slate-600" />
              ) : (
                item.icon && item.icon
              )}
              {item.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
